import styled, { css } from 'styled-components'

import { TableStyled } from 'aem-libs-react-components/src/components/lists/table'

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`

export const StyledTable = styled(TableStyled).withConfig({
  shouldForwardProp: (prop) => !['stickyFirstColumn'].includes(prop)
})<{ stickyFirstColumn?: boolean }>`
  ${({ stickyFirstColumn }) =>
    stickyFirstColumn &&
    css`
      thead th:first-child {
        position: sticky;
        left: 0;
        z-index: 2;
      }

      tbody tr {
        td:first-child {
          position: sticky;
          left: 0;
          z-index: 1;
        }
      }
    `}
`
